import React from 'react';
import { IconSVG } from '../IconSVG';
import { SupportedSVGS } from '../IconSVG/SupportedSVGs';
const Icon = ({ source, altText = '', className = '', svgStyle = undefined, }) => {
    if (SupportedSVGS[source]) {
        return React.createElement(IconSVG, { iconType: source, style: svgStyle });
    }
    return React.createElement("img", { src: source, alt: altText, className: className });
};
export default Icon;
//# sourceMappingURL=Icon.js.map